import { Hue, HueVariant } from "@/utilities/types/local"

import { Presentation } from "./Button"
import styles from "./Button.module.css"

export function buttonClasses(args: {
  hue: Hue
  variant?: HueVariant
  presentation?: Presentation
}) {
  return [hueClass(), hueVariantClass(), appearanceClass()]

  function hueClass() {
    switch (args.hue) {
      case "primary":
        return styles.primary
      case "secondary":
        return styles.secondary
      case "neutral":
        return styles.neutral
      case "success":
        return styles.success
      case "caution":
        return styles.caution
      case "danger":
        return styles.danger
      default:
        console.error(`Unhandled or unexpected hue style: ${args.hue}.`)
        return styles.primary
    }
  }

  function hueVariantClass() {
    switch (args.variant) {
      case "default":
        return styles.defaultVariant
      case "light":
        return styles.light
      case "solid":
        return styles.solid
      case "inverse":
        return styles.inverse
    }
  }

  function appearanceClass() {
    switch (args.presentation) {
      case "ghost":
        return styles.ghost
      case "link":
        return styles.link
      default:
        return styles.filled
    }
  }
}
